export const couponVerifyLoading =  ({store})  => store.couponVerifyReducer.loading;

export const couponVerifyError =  ({store})  => store.couponVerifyReducer.error;

export const couponVerifyData =  ({store})  => store.couponVerifyReducer.data;